import React, { ComponentType, FC } from 'react';

import { track } from '@adsk/acs-web-analytics';
import { Flex, Box } from '@adsk/alloy-react-box';
import { LinkButton } from '@adsk/alloy-react-button';
import theme from '@adsk/alloy-react-theme';

import { AnalyticsEvents } from '../../../constants';
import { ProductLinkVariant, PRODUCT_LINK_VARIANTS } from '../consts';

type ProductLinkProps = {
  variant?: ProductLinkVariant;
  icon?: ComponentType<{ [prop: string]: unknown }>;
  url?: string;
  label: string;
};

const ProductLink: FC<ProductLinkProps> = ({
  label,
  icon: Icon,
  variant,
  url,
}) => {
  return (
    <LinkButton
      style={{
        ...theme.typography.bodyMedium,
        color: theme.colors.black,
        display: 'flex',
        alignItems: 'center',
        padding: 0,
        marginRight: 20,
        '&:hover': {
          color: theme.colors.black,
        },
      }}
      onClick={async () => {
        if (url) {
          track(AnalyticsEvents.navigateToOtherProduct, {
            product_name: label,
          });
        }
      }}
      as="a"
      href={url}
      target={variant === PRODUCT_LINK_VARIANTS.EXTERNAL ? '_blank' : undefined}
    >
      {variant === PRODUCT_LINK_VARIANTS.EXTERNAL && (
        <Flex mr={8}>
          {Icon ? (
            <Icon />
          ) : (
            <Box
              width={22}
              height={22}
              borderRadius="50%"
              backgroundColor="adskBlue100"
            />
          )}
        </Flex>
      )}
      {variant === PRODUCT_LINK_VARIANTS.INTERNAL && Icon ? (
        <Flex
          justifyContent="center"
          alignItems="center"
          backgroundColor="adskBlue100"
          color="adskBlue500"
          width={32}
          height={32}
          borderRadius={4}
          marginRight={8}
          flexShrink={0}
        >
          <Icon size={20} />
        </Flex>
      ) : null}
      {label}
    </LinkButton>
  );
};

export default ProductLink;
